var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentStep)?_c('onboarding-camera-layout',{ref:"onboarding-camera-layout",attrs:{"headerTitle":_vm.headerTitle,"warningMessage":_vm.warningMessage,"openCamera":_vm.allowToOpenCamera},on:{"onTakePicture":_vm.handleTakePicture,"onCameraError":_vm.handleCameraError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }